<xemex-dialog-shell [title]="'installationGroups.addPartnership.title' | translate">
  <div class="p-2">
    @if (isLoading()) {
      <p class="text-sm text-gray-500">{{ 'general.loading' | translate }}</p>
    } @else if (!partnerships().length) {
      <p class="text-sm text-gray-500">
        {{ 'installationGroups.addPartnership.noAvailable' | translate }}
      </p>
    } @else {
      <xemex-select-field
        [label]="'installationGroups.addPartnership.label' | translate"
        [required]="true"
        [invalid]="partnershipControl.invalid && partnershipControl.touched"
        [errorText]="
          'error.required'
            | translate: { field: ('installationGroups.addPartnership.label' | translate) }
        "
      >
        <mat-select
          [formControl]="partnershipControl"
          [placeholder]="'installationGroups.addPartnership.placeholder' | translate"
        >
          @for (partnership of partnerships(); track partnership.partnershipOid) {
            <mat-option [value]="partnership.partnershipOid">
              {{ optionLabel(partnership) }}
            </mat-option>
          }
        </mat-select>
      </xemex-select-field>

      <div class="flex items-start gap-2 mt-3 text-xs text-gray-500">
        <mat-icon class="!text-base !w-4 !h-4 leading-4">info</mat-icon>
        <span>{{ 'installationGroups.addPartnership.hint' | translate }}</span>
      </div>
    }
  </div>

  <mat-dialog-actions actions>
    <xemex-filled-button type="button" [disabled]="!partnerships().length" (click)="onAdd()">
      {{ 'general.btnAdd' | translate }}
    </xemex-filled-button>
    <xemex-outlined-button type="button" (click)="onCancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-outlined-button>
  </mat-dialog-actions>
</xemex-dialog-shell>
